import { useEffect, useState } from "react";
import { Country } from "country-state-city";
import { Form, Select } from "antd";

const createPhoneOptions = (countries: any[]) => {
  return countries.map((country) => ({
    label: `${country.phonecode.includes("+") ? "" : "+"}${country.phonecode}`,
    value: country.isoCode,
  }));
};
function PhonePrefixSelect() {
  const [search, setSearch] = useState("");
  const [filteredCountries, setFilteredCountries] = useState<any[]>([]);
  const countries = Country.getAllCountries();

  useEffect(() => {
    let options = createPhoneOptions(countries);
    setFilteredCountries(options);
  }, []);

  const handleSearch = (value: string) => {
    const normalizedSearch = value.replace("+", "").toLowerCase();
    
    let filtered = countries.filter((country) => {
      return (
        country.name.toLowerCase().includes(value.toLowerCase()) ||
        country.isoCode.toLowerCase().includes(value.toLowerCase()) ||
        country.phonecode.replace("+", "").toLowerCase().includes(normalizedSearch)
      );
    });

    let options = createPhoneOptions(filtered);
    setFilteredCountries(options);
  };
  return (
    <Form.Item
      name="phonePrefix"
      label="Prefijo Telefónico"
      rules={[{ required: false }]}
    >
      <Select
        placeholder={"Buscar país"}
        options={filteredCountries}
        showSearch
        filterOption={false}
        onSearch={handleSearch}
      />
    </Form.Item>
  );
}

export default PhonePrefixSelect;
